import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { getAuth, onAuthStateChanged, signOut } from "firebase/auth";

import andUsLogo from "../images/logolight.png";
import tpcLogo from "../images/TPC-logo-light.png";
import "./Home.css";

const NavIcons = {
  applicant: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
      <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
      <path d="M8 7h8" />
      <path d="M8 11h8" />
    </svg>
  ),
  bursary: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M22 10v6M2 10l10-5 10 5-10 5z" />
      <path d="M6 12v5c3 3 9 3 12 0v-5" />
    </svg>
  ),
  jobs: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="2" y="7" width="20" height="14" rx="2" ry="2" />
      <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
    </svg>
  ),
  opportunity: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="12" cy="12" r="10" />
      <path d="M12 6v6l4 2" />
    </svg>
  ),
  staff: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
    </svg>
  ),
  vip: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
    </svg>
  ),
  funder: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="2" y="7" width="20" height="14" rx="2" />
      <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
      <path d="M6 10h.01M6 14h.01M6 18h.01" />
    </svg>
  ),
  supervisor: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
      <circle cx="9" cy="7" r="4" />
      <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
    </svg>
  ),
  fleetcore: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M14 16H9v-5h5v5z" />
      <path d="M14 16V8h3l2 3v5h-5z" />
      <path d="M9 16H5a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h4" />
      <circle cx="7.5" cy="16.5" r="1.5" />
      <circle cx="17.5" cy="16.5" r="1.5" />
    </svg>
  ),
};

const PLATFORMS = {
  applicant: {
    label: "Applicants & Students",
    desc: "Prospective students — access your application or learning dashboard.",
    login: "/applicant-login-manual",
    register: "/applicant-register",
  },
  bursary: {
    label: "Bursary Portal",
    desc: "Enrolled bursary learners only. Enquiries: anneke@tpc.training",
    login: "/bursary-login",
    register: "/bursary-register",
  },
  jobs: {
    label: "Job Applications",
    desc: "Apply for advertised positions at Tech Performance Centre.",
    apply: "/TPCOxyrtbOpportuntiesRef",
  },
  opportunity: {
    label: "Opportunity",
    desc: "Access assigned opportunities and complete quizzes.",
    login: "/opportunity-login",
    register: "/opportunity-registration",
  },
  staff: {
    label: "Hero Management",
    desc: "Staff and administrators — access the management dashboard.",
    login: "/hero-login-manual",
    register: "/hero-register-manual",
    org: "/heroRegisterOnlineUser",
  },
  vip: {
    label: "VIP Client Proposals",
    desc: "Authorised clients with custom proposal access.",
    login: "/vaimo-proposal-login",
    register: "/vaimo-proposal-register",
  },
  funder: {
    label: "Funder Portal",
    desc: "Funder contact officers — access your learner progress dashboard.",
    login: "/funder-login",
    register: "/funder-register",
  },
  supervisor: {
    label: "Supervisor Portal",
    desc: "Supervisors — access assigned learners' progress and reports.",
    login: "/supervisor-login",
    register: "/supervisor-register",
  },
  fleetcore: {
    label: "FleetCore",
    desc: "Sign in as a company or register a new fleet organisation.",
    login: "/fleetcore/login",
    register: "/fleetcore/signup",
  },
};

const NAV_ITEMS = [
  { key: "opportunity", label: "Opportunity" },
  { key: "vip", label: "VIP" },
  { key: "bursary", label: "Bursary" },
  { key: "jobs", label: "Jobs" },
  { key: "staff", label: "Staff" },
  { key: "applicant", label: "Applicants & Students" },
];

const parseRole = (claim = "") => {
  if (claim.startsWith("Hero-")) return "staff";
  if (/^opportunityuser/i.test(claim)) return "opportunityUser";
  if (/^jobapplicant/i.test(claim)) return "jobApp";
  if (/^applicant/i.test(claim)) return "applicant";
  if (/^learner/i.test(claim)) return "learner";
  if (claim === "vaimo-client-proposal") return "vip";

  return "guest";
};

export default function OfficeOnly() {
  const auth = getAuth();
  const navigate = useNavigate();

  const [user, setUser] = useState(null);
  const [roleCategory, setRoleCategory] = useState("guest");
  const [modalPlatform, setModalPlatform] = useState(null);
  const [navOpen, setNavOpen] = useState(false);

  useEffect(() => {
    const handleEscape = (event) => {
      if (event.key === "Escape") {
        setModalPlatform(null);
      }
    };

    if (modalPlatform) {
      document.addEventListener("keydown", handleEscape);
      document.body.style.overflow = "hidden";
    }

    return () => {
      document.removeEventListener("keydown", handleEscape);
      document.body.style.overflow = "";
    };
  }, [modalPlatform]);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (authenticatedUser) => {
      if (!authenticatedUser) {
        setUser(null);
        setRoleCategory("guest");
        return;
      }

      setUser(authenticatedUser);

      const token = await authenticatedUser.getIdTokenResult();
      setRoleCategory(parseRole(token.claims.role || ""));
    });

    return unsubscribe;
  }, [auth]);

  const logout = async () => {
    await signOut(auth);
    navigate("/");
  };

  const openConsole = () => {
    if (roleCategory === "staff") {
      navigate("/hero-dashboard");
    } else if (roleCategory === "opportunityUser") {
      navigate("/opportunity-page");
    } else if (
      roleCategory === "applicant" ||
      roleCategory === "learner"
    ) {
      navigate("/learner-dashboard");
    } else if (roleCategory === "vip") {
      navigate("/vaimo-proposal-dashboard");
    } else if (roleCategory === "jobApp") {
      navigate("/opportunity-dashboard");
    }
  };

  const platform = modalPlatform
    ? PLATFORMS[modalPlatform]
    : null;

  const openPlatform = (platformKey) => {
    setModalPlatform(platformKey);
    setNavOpen(false);
  };

  return (
    <div className="home-landing">
      <nav className="home-top-nav">
        <Link to="/" className="home-nav-logo">
          <img src={andUsLogo} alt="AndUs" />
        </Link>

        <button
          type="button"
          className={`home-nav-toggle ${navOpen ? "open" : ""}`}
          onClick={() => setNavOpen((current) => !current)}
          aria-label={navOpen ? "Close menu" : "Open menu"}
          aria-expanded={navOpen}
        >
          <span />
          <span />
          <span />
        </button>

        <div className={`home-nav-links ${navOpen ? "open" : ""}`}>
          {NAV_ITEMS.map(({ key, label }) => (
            <button
              key={key}
              type="button"
              className={`home-nav-link home-nav-link-${key}`}
              onClick={() => openPlatform(key)}
            >
              <span className="home-nav-link-icon" aria-hidden="true">
                {NavIcons[key]}
              </span>

              <span>{label}</span>
            </button>
          ))}

          <button
            type="button"
            className="home-nav-link home-nav-link-funder"
            onClick={() => openPlatform("funder")}
          >
            <span className="home-nav-link-icon" aria-hidden="true">
              {NavIcons.funder}
            </span>

            <span>Funder Portal</span>
          </button>

          <button
            type="button"
            className="home-nav-link home-nav-link-supervisor"
            onClick={() => openPlatform("supervisor")}
          >
            <span className="home-nav-link-icon" aria-hidden="true">
              {NavIcons.supervisor}
            </span>

            <span>Supervisor Portal</span>
          </button>

          <button
            type="button"
            className="home-nav-link home-nav-link-fleetcore"
            onClick={() => openPlatform("fleetcore")}
          >
            <span className="home-nav-link-icon" aria-hidden="true">
              {NavIcons.fleetcore}
            </span>

            <span>FleetCore</span>
          </button>
        </div>

        {user ? (
          <div className="home-nav-user">
            <div className="home-nav-user-pill">
              <div className="home-nav-avatar" title={user.email}>
                {user.photoURL ? (
                  <img src={user.photoURL} alt="" aria-hidden="true" />
                ) : (
                  <svg
                    className="home-nav-profile-icon"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#1f2d37"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    aria-hidden="true"
                  >
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                    <circle cx="12" cy="7" r="4" />
                  </svg>
                )}
              </div>

              <span className="home-nav-email">{user.email}</span>
            </div>

            <div className="home-nav-user-actions">
              <button
                type="button"
                className="home-nav-user-btn"
                onClick={openConsole}
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  aria-hidden="true"
                >
                  <rect x="3" y="3" width="7" height="7" />
                  <rect x="14" y="3" width="7" height="7" />
                  <rect x="14" y="14" width="7" height="7" />
                  <rect x="3" y="14" width="7" height="7" />
                </svg>

                Dashboard
              </button>

              <button
                type="button"
                className="home-nav-user-btn home-nav-user-btn-outline"
                onClick={logout}
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  aria-hidden="true"
                >
                  <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                  <polyline points="16 17 21 12 16 7" />
                  <line x1="21" y1="12" x2="9" y2="12" />
                </svg>

                Sign out
              </button>
            </div>
          </div>
        ) : (
          <div className="home-nav-user-spacer" aria-hidden="true" />
        )}
      </nav>

      {platform && (
        <div
          className="home-modal-overlay"
          onClick={() => setModalPlatform(null)}
          role="dialog"
          aria-modal="true"
          aria-labelledby="home-modal-title"
        >
          <div
            className="home-modal"
            onClick={(event) => event.stopPropagation()}
          >
            <div className="home-modal-header">
              <div className="home-modal-header-content">
                <div className="home-modal-icon-wrap">
                  <span className="home-modal-icon" aria-hidden="true">
                    {NavIcons[modalPlatform]}
                  </span>
                </div>

                <div className="home-modal-title-section">
                  <h2
                    id="home-modal-title"
                    className="home-modal-title"
                  >
                    {platform.label}
                  </h2>

                  {platform.desc && (
                    <p className="home-modal-subtitle">
                      {platform.desc}
                    </p>
                  )}
                </div>
              </div>

              <button
                type="button"
                className="home-modal-close"
                onClick={() => setModalPlatform(null)}
                aria-label="Close"
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  aria-hidden="true"
                >
                  <path d="M18 6L6 18M6 6l12 12" />
                </svg>
              </button>
            </div>

            <div className="home-modal-body">
              <div className="home-modal-actions">
                {platform.apply ? (
                  <Link
                    to={platform.apply}
                    className="home-modal-btn home-modal-btn-primary"
                    onClick={() => setModalPlatform(null)}
                  >
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      aria-hidden="true"
                    >
                      <path d="M5 12h14M12 5l7 7-7 7" />
                    </svg>

                    Submit application
                  </Link>
                ) : (
                  <>
                    <Link
                      to={platform.login}
                      className="home-modal-btn home-modal-btn-primary"
                      onClick={() => setModalPlatform(null)}
                    >
                      <svg
                        width="18"
                        height="18"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        aria-hidden="true"
                      >
                        <rect
                          x="3"
                          y="11"
                          width="18"
                          height="11"
                          rx="2"
                          ry="2"
                        />
                        <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                      </svg>

                      Log in
                    </Link>

                    <Link
                      to={platform.register}
                      className="home-modal-btn home-modal-btn-secondary"
                      onClick={() => setModalPlatform(null)}
                    >
                      <svg
                        width="18"
                        height="18"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        aria-hidden="true"
                      >
                        <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                        <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
                      </svg>

                      Register
                    </Link>

                    {platform.org && (
                      <Link
                        to={platform.org}
                        className="home-modal-btn home-modal-btn-tertiary"
                        onClick={() => setModalPlatform(null)}
                      >
                        <svg
                          width="18"
                          height="18"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          aria-hidden="true"
                        >
                          <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
                        </svg>

                        Register new organisation
                      </Link>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      {user && (
        <div className="login-box">
          Signed in as <strong>{user.email}</strong>

          <button
            className="home-btn small"
            onClick={openConsole}
          >
            My Console
          </button>

          <button
            className="home-btn small btn-secondary"
            onClick={logout}
          >
            Log Out
          </button>
        </div>
      )}

      <main className="home-hero">
        <img
          src={andUsLogo}
          alt="AndUs AI Systems"
          className="home-main-logo"
        />

        <h1 className="home-title">
          Welcome to AndUs AI Systems
        </h1>

        <div className="partner-banner">
          <span>
            Proud Quality Partner to Tech Performance Centre
          </span>

          <img
            src={tpcLogo}
            alt="TPC"
            className="tpc-logo"
          />
        </div>
      </main>
    </div>
  );
}
